import type { Testimonial } from '../types/content'

/**
 * CONTENIDO DE EJEMPLO — REEMPLAZAR ANTES DE PUBLICAR.
 * Estos textos, nombres y fotos son de muestra para mostrar el diseño de la
 * sección. Deben sustituirse por testimonios reales (con autorización de cada
 * persona) y por sus fotos reales. No publicar testimonios inventados.
 */
export const testimonials: Testimonial[] = [
  {
    id: 'testimonio-1',
    name: 'Marisol R.',
    location: 'Miami, FL',
    quote:
      'Llegué muy perdida con un tema de pareja y lo primero que valoré fue la seriedad de la consulta. Me explicaron el trabajo paso a paso y en todo momento sentí respeto y discreción.',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/fc0229cb-1ef2-453a-a8be-ac7da11b548e.jpg',
  },
  {
    id: 'testimonio-2',
    name: 'Andrés M.',
    location: 'Hialeah, FL',
    quote:
      'Buscaba una consulta de protección y me atendieron sin prisa, escuchando mi caso. Me dijeron con claridad qué se podía hacer y qué materiales se necesitaban, sin prometerme nada.',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/f1cd6135-effc-4b54-867a-e63ad23a51ba.jpg',
  },
  {
    id: 'testimonio-3',
    name: 'Yamileth C.',
    location: 'Orlando, FL',
    quote:
      'Lo que más agradezco es la privacidad y el trato. Fue una consulta personal, tranquila, y salí entendiendo mucho mejor mi situación y las tradiciones detrás del trabajo.',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/96bb82f0-47ee-4fbc-b0a2-bda290a31fc7.jpg',
  },
]
